"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _reactColor = require("react-color");

var _Scaffold = _interopRequireDefault(require("../Scaffold"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Color Picker component that returns hex string, rgb object and RGBA object.
 */
var ColorPicker =
/*#__PURE__*/
function (_Component) {
  _inherits(ColorPicker, _Component);

  function ColorPicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ColorPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ColorPicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleValueChange", function (value) {
      return _this.props.form.setFieldValue(_this.props.field.name, _this.getColor(value));
    });

    _defineProperty(_assertThisInitialized(_this), "state", {
      displayColorPicker: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.setState({
        displayColorPicker: !_this.state.displayColorPicker
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        displayColorPicker: false
      });
    });

    return _this;
  }

  _createClass(ColorPicker, [{
    key: "getColor",
    value: function getColor(color) {
      var mode = this.props.colorMode || "hex";

      if (typeof color === "string") {
        return color;
      }

      if (mode in color) {
        if (mode === "rgb" && this.props.disableAlpha) {
          return (0, _omit["default"])(color[mode], ["a"]);
        }

        return color[mode];
      }

      return color;
    }
  }, {
    key: "isAlphaDisabled",
    value: function isAlphaDisabled() {
      var _this$props = this.props,
          _this$props$colorMode = _this$props.colorMode,
          colorMode = _this$props$colorMode === void 0 ? "hex" : _this$props$colorMode,
          disableAlpha = _this$props.disableAlpha;

      if (colorMode !== "rgb") {
        return true;
      }

      return disableAlpha;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          className = _this$props2.className,
          field = _this$props2.field,
          _this$props2$form = _this$props2.form,
          touched = _this$props2$form.touched,
          errors = _this$props2$form.errors,
          id = _this$props2.id,
          label = _this$props2.label,
          _this$props2$withScaf = _this$props2.withScaffold,
          withScaffold = _this$props2$withScaf === void 0 ? true : _this$props2$withScaf;
      var color = field.value;
      var colorStyle;

      switch (_typeof(color)) {
        case "object":
          if ("r" in color && "g" in color && "b" in color) {
            if ("a" in color) {
              colorStyle = "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")");
            } else {
              colorStyle = "rgb(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ")");
            }
          }

          break;

        default:
          colorStyle = color || "transparent";

          if (color === "transparent") {
            color = {
              a: 100
            };
          }

      }

      var colorStyles = colorStyle ? {
        backgroundColor: colorStyle
      } : {};

      var ColorInput = _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.root, className)
      }, _react["default"].createElement("div", {
        className: classes.swatch,
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        className: classes.color,
        style: colorStyles
      })), this.state.displayColorPicker ? _react["default"].createElement("div", {
        className: classes.popover
      }, _react["default"].createElement("div", {
        className: classes.cover,
        onClick: this.handleClick
      }), _react["default"].createElement(_reactColor.SketchPicker, {
        color: color,
        onChange: this.handleValueChange,
        disableAlpha: this.isAlphaDisabled()
      })) : null);

      if (withScaffold) {
        return _react["default"].createElement(_Scaffold["default"], {
          id: id,
          label: label,
          error: (0, _get["default"])(touched, field.name) && (0, _get["default"])(errors, field.name)
        }, ColorInput);
      } else {
        return ColorInput;
      }
    }
  }]);

  return ColorPicker;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: {
      position: "relative"
    },
    color: {
      height: "28px",
      borderRadius: "2px"
    },
    swatch: {
      padding: "5px",
      background: "#fff",
      border: "1px solid ".concat(theme.colors.gray300),
      cursor: "pointer"
    },
    popover: {
      position: "absolute",
      zIndex: "2"
    },
    cover: {
      position: "fixed",
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiColorPicker"
})(ColorPicker);

exports["default"] = _default;